// Billing errors now carry an object detail ({error: "..."}) for the gated
// cases; turn any of the shapes into a message that is safe to show.
export function billingErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  switch (detail?.error) {
    case 'account_not_activated':
      return "Your account isn't switched on yet.";
    case 'reauth_required': // only reaches the caller if the step-up was cancelled
      return 'Please confirm it\'s you to continue.';
    default:
      return fallback;
  }
}
